import React from "react";
import * as S from "./styles";
export var Label = function Label(_ref) {
  var children = _ref.children;
  return React.createElement(S.Wrapper, null, children);
};